import { z } from 'zod';

// Zod probes once whether eval is allowed; the Content-Security-Policy forbids it, so the probe
// only logs a CSP error. Skip it (validation works the same without eval). This is its own module,
// imported first in main.tsx, because imports run before main.tsx's own code.
z.config({ jitless: true });
